import styled from 'styled-components';
import { mixins } from '@jarvis/react-portal-addons';
import primitives from '@veneer/primitives';
import { Button as VeneerButton } from '@veneer/core';

export const Container = styled.div`
  position: relative;
  background-color: ${primitives.color.hpBlue7};
  box-sizing: border-box;
  height: fit-content;
  min-height: ${props => (props.accountHasDevice ? 0 : '392px')};
  padding: 0 0 28px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 1660px;

  ${mixins.md(`
    min-height: ${props => (props.accountHasDevice ? 0 : '536px')};
    border-radius: 16px;
    padding: 32px 0 40px 0;
  `)}
`;

export const Title = styled.h3`
  margin: 20px 32px 20px 32px;
  color: ${primitives.color.white};
  font-weight: 700 !important;
  opacity: 1;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ accountHasDevice }) => accountHasDevice && mixins.md(`
    position: absolute;
    left: 32px;
    margin-top: 20px;
    transition: opacity 0.3s ease-in-out;
  `)}

  ${({ hide }) => hide && mixins.md(`
    opacity: 0;
  `)}

  ${mixins.md(`
    max-width: 46%;
    align-self: center;
  `)}

  ${mixins.lg(`
    max-width: 50%;
    margin: 0 20px 0 0;
  `)}
`;

export const PrinterCarouselContainer = styled.div`
  ${mixins.lg(`
    margin: 0 0 0 0;
  `)}
`;

export const TitleAndNotificationsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;

  ${mixins.md(`
    padding: 0 32px;
    margin-bottom: 40px;
    flex-direction: row-reverse;
  `)}
`;

export const NotificationsWidgetContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 64px);
  transition: max-height 0.3s ease-in-out;
  z-index: 5;
  position: absolute;

  ${mixins.md(`
    position: unset;
    transition: width 0.3s ease-in-out, max-height 0.3s ease-in-out, height 0.3s ease-in-out;
    float: right;
    z-index: unset;
    width: 368px;
  `)}

  ${({ collapsed }) => collapsed && `
    max-height: 64px;
    height: 64px;
  `}

  ${({ expanded }) => expanded && `
    width: 100%;
    position: fixed;
    max-height: calc(100vh - 76px);
  `}

  ${({ collapsed }) => collapsed && mixins.md(`
    height: auto;
    max-height: 108px;
    animation: unset;
    width: 300px;
  `)}

  ${({ collapsed }) => collapsed && mixins.lg(`
    width: 368px;
    max-height: 64px;
    height: 64px;
  `)}

  ${({ expanded }) => expanded && mixins.md(`
    max-height: 60vh;
    height: auto;
    width: 100%;
  `)}
`;

export const MessageContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > p {
    color: ${primitives.color.white};
    text-align: center;
    padding: 0 32px;
  }
`;

export const Button = styled(VeneerButton)`
  && {
    background-color: ${primitives.color.white};
    color: ${primitives.color.gray12};
    margin-top: 40px;

    &:hover {
      background-color: ${primitives.color.white};
      color: ${primitives.color.gray12};
    }
  }
`;

export const PadArea = styled.div`
  height: 64px;
`;
